import {
  Form,
  TextInput,
  TextArea,
  Select,
  SelectItem,
  Button,
  Dropdown,
  MultiSelect,
  ComboBox,
  DropdownSkeleton,
  TextInputSkeleton,
  TextAreaSkeleton,
  DataTableSkeleton,
} from "carbon-components-react";

const Input = (props) => {
  let inputElement = null;

  const cleanProps = () => {
    let { elementType, register, control, ...cleanProps } = props;
    return cleanProps;
  };

  switch (props.elementType) {
    case "textarea":
      inputElement = (<TextAreaSkeleton />);
      break;
    case "hidden":
      inputElement = null;
      break;
      inputElement = (<DropdownSkeleton />);
      break;
    case "multiselect":
      inputElement = (
          <DataTableSkeleton columnCount={2} rowCount={5} showToolbar={false} compact={true} showHeader={false}/>
        )
      break;
    default:
      inputElement = (
        <TextInputSkeleton />
      );  
  }

  return <div style={{ marginBottom: "2rem" }}>{inputElement}</div>;
};

export default Input;
